<template>
  <div>
    <booking-infor
      class="mb-3"
      :booking-info="bookingInfo"
    ></booking-infor>
    <!-- <p>
      {{ message }}
    </p> -->
    <section>
      <div>From: {{ fromCoachName }}</div>
      <div>Transfer Status: {{ transferStatus[transferStatusId] }}</div>
      <div>Message:</div>
      <div>{{ message }}</div>
    </section>
    <v-row
      v-show="showBtn"
      class="mb-10 mt-10"
    >
      <v-col>
        <div class="text-center align-center justify-center">
          <v-btn
            fab
            dark
            color="#FF5252"
            @click="handleReject"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </v-col>
      <v-col>
        <div
          class="text-center align-center justify-center"
        >
          <v-btn
            fab
            dark
            color="#00BFA5"
            @click="handleAccept"
          >
            <v-icon>mdi-check</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>
<script setup>
import { ref, onMounted, toRefs, computed, watch, nextTick } from 'vue'
import BookingInfor from './BookingInfo'
import { acceptBookingTransfer, rejectBookingTransfer } from '@/api/bookedCourse'
import { getUserData } from '@/utils/auth'

const userRecord = getUserData()

const transferStatus = ref({
  1: 'Pending',
  2: 'Accepted',
  3: 'Rejected',
  4: 'Cancelled',
})

const props = defineProps({
  transferStatusId: {
    type: Number,
    default: -1,
  },
  bookingTransfer: {
    type: Object,
    default() {
      return null
    },
  },
  notificationMessage: {
    type: Object,
    default() {
      return null
    },
  },
  bookingInfo: {
    type: Object,
    default() {
      return {
        bookingNo: '',
        course: {
          courseCode: '',
          courseName: '',
        },
        userRecord: {
          fullName: '',
        },
        assignedCoach: {
          fullName: '',
        },
        center: {
          description: '',
        },
        courseStartTime: '',
        courseEndTime: '',
      }
    },
  },
})

const { bookingInfo, notificationMessage, transferStatusId, bookingTransfer } = toRefs(props)

// const transferStatusID = ref(-1)

// function getLatestTransferRecord() {
//   console.log('bookingInfo.value.id', bookingInfo.value.id)

//   getBookingTransfer({
//     id: bookingInfo.value.id,
//   }).then(response => {
//     console.log('response', response)
//     if (response.data && response.data.record) {
//       transferStatusID.value = response.data.record.transferStatusID

//       console.log('transferStatusID', transferStatusID.value)
//     }
//   })
// }
// const showBtn = computed(() => transferStatusID.value < 2)

// const showBtn = computed(() => {
//   //  && bookingInfo.value && bookingInfo.value.assignedCoachID !== userRecord.userToken.userRecordID
//   if (transferStatusId < 2) {
//     return true
//   }

//   return false
// })

const showBtn = ref(false)

// defineExpose({ transferStatusID })

const message = computed(() => {
  if (notificationMessage.value != null) {
    return notificationMessage.value.content
  }

  return ''
})
const fromCoachName = computed(() => {
  if (bookingInfo.value.assignedCoach) {
    return bookingInfo.value.assignedCoach.fullName
  }

  return ''
})

const emit = defineEmits(['close'])
function handleAccept() {
  console.log('bookingInfo.value', bookingInfo.value)
  acceptBookingTransfer({
    id: bookingInfo.value.id,
    notificationMessageID: notificationMessage.value.id,
    bookingTransferID: bookingTransfer.value.id,
  }).then(response => {
    if (response.code === 20000) {
      // transferStatusID.value = -1
      emit('close')
    }
  })
}

function handleReject() {
  if (confirm('Are you sure to reject this transfer request?')) {
    rejectBookingTransfer({
      id: bookingInfo.value.id,
      notificationMessageID: notificationMessage.value.id,
      bookingTransferID: bookingTransfer.value.id,
    }).then(response => {
      if (response.code === 20000) {
        emit('close')
      }
    })
  }
}

function updateShowBtn(newValue) {
  nextTick(() => {
    if (newValue < 2 && bookingInfo.value && bookingInfo.value.assignedCoachID !== userRecord.userToken.userRecordID) {
      showBtn.value = true
    } else {
      showBtn.value = false
    }
  })
}

watch(transferStatusId, newValue => {
  // console.log('transferStatusId', newValue)
  updateShowBtn(newValue)
})

onMounted(() => {
  updateShowBtn(transferStatusId.value)
})
</script>
